export default __webpack_public_path__ + "static/media/logo-black-revised.8796e6af.png";